import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import mainTheme from '../../themes/mainTheme';
import Container from '@material-ui/core/Container';

const useStyles = makeStyles((theme) => ({
  centeredContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(1),
  },
}));

const PanelLoadingIndicator = () => {
  const classes = useStyles(mainTheme);
  return (
    <Container maxWidth="xs" classes={{root: classes.centeredContainer}}>
      <CircularProgress color="primary" />
    </Container>
  );
};

export default PanelLoadingIndicator;
